export default __webpack_public_path__ + "f4782d733c71b6f6c4f4548140c30450.svg";